<ng-container [ngSwitch]="view">
    <ms-inline-tooltip *ngSwitchCase="'Pair'">
        <div class="participants-pair-game">
            @for (participantInfo of participantInfos; track $index) {
                <div class="participant-wrapper" [class.image]="showParticipantImage">
                    <div class="participant-container">
                        <ms-participant-image
                            *ngIf="participantInfo.isSingleContestant && enableImages"
                            [sportId]="event.sport.id"
                            [participantImage]="participantInfo.participant.image"
                            [showLogoColor]="showLogoColor" />
                        <ng-template #participant>
                            <div
                                #tooltipContent
                                class="participant"
                                *ngIf="!participantInfo.rank && !participantInfo.winLossStats && !participantInfo.pitcher; else statsTemplate"
                                [class.highlight]="shouldHighlight(participantInfo.participant)">
                                {{ participantInfo.participantNames[0] }}
                                <span class="participant-country" *ngIf="participantInfo.isSingleContestant">{{
                                    participantInfo.participant.country
                                }}</span>
                                <div class="second-participant" *ngIf="!participantInfo.isSingleContestant">
                                    {{ participantInfo.participantNames[1] }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-container *ngIf="showRedCardsInSoccer; else defaultParticipantTemplate">
                            <div class="participant-details">
                                <ng-container *ngTemplateOutlet="participant" />
                                <div class="participant-penalty-cards">
                                    <span class="red-card" *ngFor="let redCard of participantInfo.redCards"></span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #defaultParticipantTemplate>
                            <ng-container *ngTemplateOutlet="participant" />
                        </ng-template>
                        <ng-template #statsTemplate>
                            <div class="participant-details">
                                <div class="participant-info">
                                    <div class="participant-rank" *ngIf="!!participantInfo.rank">{{ participantInfo.rank }}</div>
                                    <div #tooltipContent class="participant" [class.highlight]="shouldHighlight(participantInfo.participant)">
                                        {{ participantInfo.participantNames[0] }}
                                        <span
                                            class="participant-country"
                                            *ngIf="participantInfo.isSingleContestant && !participantInfo.winLossStats && !participantInfo.pitcher"
                                            >{{ participantInfo.participant.country }}</span
                                        >
                                        <div class="second-participant" *ngIf="!participantInfo.isSingleContestant">
                                            {{ participantInfo.participantNames[1] }}
                                        </div>
                                    </div>
                                </div>
                                <div class="betradar-stats" *ngIf="!event.live">
                                    <div class="win-loss-stats" *ngIf="!!participantInfo.winLossStats">
                                        {{ participantInfo.winLossStats }}
                                    </div>
                                    <div class="pitcher-name" *ngIf="!!participantInfo.pitcher">
                                        {{ participantInfo.pitcher }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <span class="away-indicator" *ngIf="showAwayIndicator(participantInfo.participant)" [msAutomation]="'grid-away-indicator'">
                            {{ sitecore.globalMessages.AwayIndicator }}
                        </span>
                    </div>
                    <ms-fixture-form *ngIf="event.fixtureForm" [event]="event" [participantType]="participantInfo.participant.type" />
                </div>
            }
        </div>
    </ms-inline-tooltip>
    <ms-inline-tooltip *ngSwitchCase="'Tournament'">
        <div #tooltipContent class="participants-tournament-game">
            <div class="tournament">{{ event.name }}</div>
            <div class="tournament tournament-leader" *ngIf="leader">
                1. {{ participantInfos[0].participantNames[0]
                }}<span class="participant-country" *ngIf="participantInfos[0].isSingleContestant">{{
                    participantInfos[0].participant.country
                }}</span>
                <div class="second-participant" *ngIf="!participantInfos[0].isSingleContestant">
                    {{ participantInfos[0].participantNames[1] }}
                </div>
            </div>
        </div>
    </ms-inline-tooltip>
    <ms-inline-tooltip *ngSwitchCase="'LeaderboardGame'">
        <div class="leaderboard-game">
            <div #tooltipContent class="event-name">{{ event.name }}: {{ event.league.name }}</div>
        </div>
    </ms-inline-tooltip>
    <ms-inline-tooltip *ngSwitchCase="'Combi'">
        <div #tooltipContent class="participants-combi-game">
            <div class="combi-league combi-league-name">{{ event.name }}</div>
            <div class="combi-league combi-league-option">{{ option }}</div>
        </div>
    </ms-inline-tooltip>
</ng-container>
